import React, { useState, useEffect } from 'react'
import useWindowSize from 'react-use/lib/useWindowSize'
import Confetti from 'react-confetti'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
  pointer-events: none;
`

const CelebracionConfetti = () => {
  const [show, setShow] = useState(false)
  const { width, height } = useWindowSize()

  useEffect(() => {
    setTimeout(() => {
      setShow(true)
    }, 1500)
  }, [])

  return <Wrapper>{show && <Confetti width={width} height={height} />}</Wrapper>
}

export default CelebracionConfetti
